import React, { useContext } from 'react';
import ColorsContext from './ColorsContext';
import ISLTable from './ISLTable';

export default function EddiTable(props) {
  const { regionData, monyr, areaType } = props;
  const { levelColors } = useContext(ColorsContext);
  
  let droughtRegions = [
    "Western",
    "Connecticut River",
    "Central",
    "Northeast",
    "Southeast",
    "Cape Cod",
    "Islands"
  ];

  const basins = [
    "Blackstone",
    "Boston Harbor",
    "Buzzards Bay",
    "Cape Cod",
    "Charles",
    "Chicopee",
    "Connecticut",
    "Deerfield",
    "Farmington",
    "French",
    "Housatonic",
    "Hudson",
    "Ipswich",
    "Islands",
    "Merrimack",
    "Millers",
    "Narragansett Bay",
    "Nashua",
    "North Coastal",
    "Parker",
    "Quinebaug",
    "Shawsheen",
    "South Coastal",
    "SuAsCo",
    "Taunton",
    "Ten Mile",
    "Westfield"
  ];

  const counties = [
    "Barnstable",
    "Berkshire",
    "Bristol",
    "Dukes",
    "Essex",
    "Franklin",
    "Hampden",
    "Hampshire",
    "Middlesex",
    "Nantucket",
    "Norfolk",
    "Plymouth",
    "Suffolk",
    "Worcester"
  ];

  var droughtAreas;
  switch (areaType) {
    case 'region':
      droughtAreas = droughtRegions;
      break;
    case 'basin':
       droughtAreas = basins;
      break;
    case 'county':
      droughtAreas = counties;
      break;
    default:
      console.log(`Bad areaType selection - ${areaType}`);
      droughtAreas = droughtRegions;
  }
  
  return (
    <>
      <table className="pcpnTable-container">
        <caption>
          {"2-Month EDDI Summary for"} {monyr} <br />
          <ISLTable />
        </caption>
        <thead>
          <tr>
            <th scope="col">{areaType[0].toUpperCase() + areaType.slice(1)}</th>
            <th scope="col" abbr="Median">{"Median of individual grid cell values (percentile)"}</th>
          </tr>
        </thead>
        <tbody>
          {droughtAreas.map((rd, i) => (
            <tr key={i}>
              <th scope="row">{rd.replace("Connecticut River","CTRV")}</th>
              <td 
                style={{
                  backgroundColor: levelColors[regionData[rd]["02mn_level"]], 
                  color: regionData[rd]["02mn_level"] !== 4 ? "black" : "white"
                }}
              >
                {regionData[rd]["02mn_pctl"] !== -999 ? regionData[rd]["02mn_pctl"] : "NA"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}